import {Component, ChangeDetectorRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {CommonUtils} from '../../../services/common-utils';
import {ApiService} from '../../../services/api.service';
import {ErrorService} from '../../../shared/error-page/service/error-service';
import {Subscription} from 'rxjs';
import {Title} from '@angular/platform-browser';
import {Constants} from '../../../constants/ebtq-constants';
import {SubmissionWrapper} from '../../../model/submissionWrapper';
import {UtilityService} from '../../../services/utility-service';

@Component({
  standalone: false,
  selector: 'app-upload-file',
  templateUrl: './upload-file.component.html',
  styleUrls: ['./upload-file.component.scss']
})

export class UploadFileComponent implements OnInit, OnDestroy {
  mFiles = [];
  inputMetaData: any;
  sendInputMetaData: any;
  appCode: any;
  fileToUpload: File = null;
  private subscription = new Subscription();
  base64textString: string;
  dealName: string;
  types: any[];
  selectedFileType: string;
  typeCode: string;
  successMessage: string;
  showMessage: boolean;
  showErrorDiv: boolean;
  errHeading: string;
  errMessage: string;
  showValidationErrors: boolean;
  serviceNumber: number;
  fileName: string;
  trackingId: string;
  totRecord: string;
  errorMessage: string[] = [];
  @ViewChild('fileUpload') fileUploadComponent: any;
  isSuccess = false;
  containsError = false;
  errorMsg: string;
  private request: any;
  fileUploadId: string;
  userId: string;
  pageHeader: string;
  utilService: UtilityService;
  isExternal  = false;
  serNumber: any[];

  constructor(private commonUtils: CommonUtils, private apiService: ApiService, private router: Router, private route: ActivatedRoute,
              private errorService: ErrorService, private titleService: Title, private cdr: ChangeDetectorRef) {
    this.titleService.setTitle('Upload Reverse Mortgage File');
    this.utilService = new UtilityService();
  }

  ngOnInit(): void {
    sessionStorage.setItem('currentSubMenuOption', 'RMServicing');
    // get the servicerNumber for external users
    const isExternal = JSON.parse(sessionStorage.getItem('isExternal'));
    this.isExternal = (isExternal == null) ? false : isExternal;
    this.serviceNumber = this.utilService.get9DigitSeller(this.isExternal);
    this.appCode = Constants.APP_CODE;
    this.fileUploadId = '';
    this.pageHeader = Constants.UPLOAD_PAGE_HEADER;
    this.route.params.subscribe(params => {
      if (params && params.dealName) {
        this.dealName = params.dealName;
      }
    });


    this.showValidationErrors = false;
    this.types = [];
    this.types.push({label: 'Transactions', value: 'Transactions'});
    this.types.push({label: 'TrialBalance', value: 'TrialBalance'});
    this.types.push({label: 'ServicingTransfers', value: 'ServicingTransfers'});
    // Default dropdown value
    this.selectedFileType = 'Transactions';
    this.cdr.detectChanges();
  }


  gotoHome() {
    this.router.navigateByUrl(Constants.UPLOAD_URL);
  }

  onUploadFile(event: any) {
    this.inputMetaData = event;
    if (this.inputMetaData.status === 'COMPLETED') {
      console.log('completed for user ' + event.userId);
      this.userId = event.userId;
      this.fileUploadId = event.fileUploadId;
      this.cdx_file_update();
    }
  }

  uiValidation() {
    let validate = false;
    this.errorMessage = [];
    if (this.serviceNumber === undefined || this.serviceNumber === null  || (this.serviceNumber.toString()).length !== 9) {
      this.errorMessage.push(Constants.SEL_NUM_ERR);
      validate = true;
    }

    if (this.fileName === undefined || this.fileName === null || this.fileName.length === 0) {
      this.errorMessage.push(Constants.SEL_UPLD_FILE);
      validate = true;
    }
    else if (this.fileName.substring(0, this.fileName.lastIndexOf('.')).length > 46) {
      // Filename will be appended with submission ID
      // so check that the file name can not be greater than 46 characaters
      this.errorMessage.push(Constants.INVALID_FILE_NAME_LENGTH);
      validate = true;
    }

    const reg = /(.*?)\.(dat|txt)$/;
    if (!this.fileName.match(reg)) {
      this.errorMessage.push(Constants.INVALID_FILE_TYPE);
      validate = true;
    }

    return validate;
  }

  onErrorFile(_event: any) {
    console.log('onErrorFile');

  }

  onClearFile() {
  }

  onSelectFile(event: any, id: any) {
    // reset success message
    this.showMessage = false;
    this.successMessage = '';
    this.showValidationErrors = false;
    this.fileToUpload = event.files[0];

    if (this.fileToUpload) {
      this.fileName = this.fileToUpload.name;
    }
    if (this.uiValidation()) {
      this.showValidationErrors = true;
    }

    // depending on the validations errors proceed to file import
    this.proceedToFileImport(id);
  }

  cdx_file_update() {
    if (this.selectedFileType === 'Transactions') {
      this.typeCode = Constants.TransTypeCode;
    }
    if (this.selectedFileType === 'TrialBalance') {
      this.typeCode =  Constants.TrialBalTypeCode;
    }
    if (this.selectedFileType === 'ServicingTransfers') {
      this.typeCode =  Constants.ServTransBalTypeCode;
    }

    console.log('Servicer Number is ' + this.serviceNumber);
    const submissionWrapper = new SubmissionWrapper();
    // substring and get the first 5 digits of the seller servicer number
    // and convert it to number using unary + operator
    submissionWrapper.sellerNo = + ((this.serviceNumber + '').substring(0, 5));
    submissionWrapper.fileName = this.fileName;
    submissionWrapper.fileUploadId = this.fileUploadId;
    submissionWrapper.submissionType = this.typeCode;
    submissionWrapper.userId = this.userId;

    this.apiService.copyFileFromCDXToS3Bucket(submissionWrapper)
      .subscribe(
        (data: any) => {
          this.pageHeader = Constants.SUCC_UPLOAD_PAGE_HEADER;
          this.isSuccess = true;
          this.containsError = false;
          this.totRecord = data.totReqstCnt;
          this.trackingId = data.trkgID;
          this.fileName = data.fileNme;
          this.titleService.setTitle(this.pageHeader);
          this.cdr.detectChanges();
        },
        error => {
          this.errorService.announceError(error);
        });

    // error announcement
    this.errorService.errorAnnouncedSource$.subscribe(
      message => {
        this.errorMsg = message;
        this.containsError = true;
        this.cdr.detectChanges();
      });
  }

  private proceedToFileImport(id: any) {
    if (!this.showValidationErrors) {
      const reader = new FileReader();
      reader.onload = this._handleReaderLoaded.bind(this);
      reader.readAsBinaryString(this.fileToUpload);
    } else {
      // clear the file selection due to validation errors
      id.clear();
    }
  }

  sendMetaData() {
    this.mFiles.map((x) => (x.status = 'COMPLETED'));
    this.sendInputMetaData = this.mFiles;
  }

  onUploadHandler() {
  }

  finalMeta(_event: any) {
  }

  _handleReaderLoaded(readerEvt) {
    const binaryString = readerEvt.target.result;
    this.base64textString = btoa(binaryString);
  }

  resetFileUpload() {
    this.fileUploadComponent.clear();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

}
